import ApiClient from "./ApiClient";

export const fetchOverviewData = async ({ token, year }) => {
    const response = await ApiClient.get('/api/clients/overview_data', {
        params: {
            year: year,
        },
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });

    return response.data;
}